import React from 'react';
import { motion } from 'framer-motion';

export function NBRLabel({ text }: { text: string }) {
  return (
    <motion.span
      layoutId="nbr-label"
      className="inline-block mr-2 shrink-0 rounded-[4px] px-[7px] px-[2px] bg-brand-openButtonBackground text-brand-nextBestAction text-[10px] leading-[15px] font-semibold align-text-top uppercase"
    >
      {text}
    </motion.span>
  );
}
